import Phaser from 'phaser';

import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { StartViewModel } from './start-view-model';
import { Subscription } from 'rxjs';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class StartView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;

  protected viewModel: StartViewModel;
  protected startButton: Phaser.GameObjects.Image;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: StartViewModel) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.viewModel = viewModel;

    const buttonAsset = viewModel.buttonAsset;
    this.startButton = scene.add.image(0, 0, buttonAsset.type).setOrigin(0, 0).setInteractive();
    this.startButton.on(Phaser.Input.Events.POINTER_UP, (_pointer: Phaser.Input.Pointer) => {
      viewModel.startClicked();
      this.showButton(false);
    });

    this.add([this.startButton]);
    this.setName(StartView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      viewModel.onShowStartButtonTrigger?.subscribe((show) => {
        this.showButton(show);
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.resizeBackground(gameSizeMetrics, this.viewModel.buttonAsset);
  }

  public resizeBackground(gameSizeMetrics: GameSizeMetrics, gameAsset: GameAsset): void {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    const xPos = (gameSizeMetrics.widthDpr - gameAsset.dimensions.width * calc.scaleFactor) * 0.5;

    const yPos =
      (layoutConfig.vPadding + layoutConfig.pileHeight * 2 + layoutConfig.vSpacing * 3) *
        calc.scaleFactor -
      gameAsset.dimensions.height * 0.5 * calc.scaleFactor;

    this.startButton.setPosition(xPos, yPos);
    this.startButton.setDisplaySize(
      gameAsset.dimensions.width * calc.scaleFactor,
      gameAsset.dimensions.height * calc.scaleFactor,
    );
  }

  private showButton(show: boolean) {
    this.visible = show;
    if (show) {
      this.startButton.setInteractive();
    } else {
      this.startButton.disableInteractive();
    }
  }
}
